import { LanguageTestTemplate } from '../../lib/types/models/language-test/language-test-template'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const deleteLanguageTestTemplate = (id: number) =>
  restApiClient
    .url(constructApiUrl(API.languageTest.deleteTemplate.url, { id }))
    .delete<LanguageTestTemplate>()
